import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const useReorderTrackmanParameterCategories = () => {
  const service = useServices().trackmanParameterCategoriesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (categoryIds: string[]) => service.reorderCategories({ categoryIds }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminTrackmanParameterCategories'] });
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
